import { render } from "./TaskConstructionalPraxis.vue?vue&type=template&id=37f0eaea"
import script from "./TaskConstructionalPraxis.vue?vue&type=script&lang=js"
export * from "./TaskConstructionalPraxis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__